import request from './index'

export const getNewsList = (data) =>{
  return request.post('/user/event/news/list',data)
}
export const getNewsItemDetail = (code) =>{
  return request.get(`/user/event/news/getContent/${code}`)
}
